// src/api/nft.js
import { apiGet } from './http';

/**
 * GET /app/nft/overview
 * NFT顶部统计
 * - holdCount 持有张数
 * - totalPrincipalUsdt 总持仓金额
 * - totalSettledProfitUsdt 累计收益
 * - maxDailyRate 当前最高日收益率
 *
 * @param {Object} config 可传 { silent: true }
 */
export function fetchNftOverview(config = {}) {
  return apiGet('/app/nft/overview', {}, config);
}

/**
 * GET /app/nft/orders
 * NFT持仓列表（分页）
 *
 * @param {Object} params
 *  - page: number (默认 1)
 *  - size: number (默认 20)
 * @param {Object} config 可传 { silent: true }
 */
export function fetchNftOrders(params = {}, config = {}) {
  const {
    page = 1,
    size = 20,
  } = params || {};

  return apiGet(
    '/app/nft/orders',
    { page, size },
    config
  );
}

/**
 * GET /app/nft/order-list
 * NFT持仓列表（不分页）
 *
 * @param {Object} config 可传 { silent: true }
 */
export function fetchNftOrderList(config = {}) {
  return apiGet('/app/nft/order-list', {}, config);
}